// After a Save All of an environment workspace, the shell's environment list (the branch selector's chips, the
// game-time offsets of section 3.4) re-reads the environments (spec/dashboard.md section 9.12).
import { useEffect } from 'react';
import { gameKey } from '../../shell/GameContext';
import { queryCache } from '../../workspace/cache';
import type { Workspace } from '../../workspace/Workspace';

export function useEnvironmentsRefresh(workspace: Workspace, org: string, game: string): void {
  const lastSave = workspace.lastSave;
  useEffect(() => {
    if (lastSave && !lastSave.dryRun && lastSave.saved > 0) queryCache.invalidate(gameKey(org, game, 'envs'));
  }, [lastSave, org, game]);
}
